<template>
	<div class="InputDropdown">
		<InputTextbox
			:dropdown="true"
			type="text"
			:label="label"
			:saturn="vm.saturn"
			:invalid="invalid"
			:disabled="disabled"
			:infoIconObj="infoIconObj"
			:clearable="clearable"
			:placeholder="placeholder"
			:dropdownFocused="focused"
			:height="height"
			:width="width"
			:cssClass="cssClass"
			:nothingSelected="nothingSelected"
		>
			<template #dropdown>
				<select
					v-model="vm.saturn"
					:disabled="disabled"
					@change="onChangeHandler"
					@blur="onBlurHandler"
					@focus="onFocusInput"
					@cleared="handleClear"
				>
					<!--IF WE ARE WORKING WITH OBJECTS, CHECK FOR NULL..... ELSE - CHECK IF BLANK-->
					<option
						:value="blankValue"
						v-if="nothingSelected && !vm.value"
					>
						{{ nothingSelected }}
					</option>
					<option
						:value="nullValue"
						v-else-if="nothingSelected && vm.value"
					>
						{{ nothingSelected }}
					</option>

					<option
						v-for="(item, index) in vm.list"
						v-bind:key="index"
						:value="itemValue(item)"
						:disabled="itemIsDisabled(item)"
						:style="customOptionStyle ? customOptionStyle(item) : ''"
					>
						<div
							v-if="unicodeIcon"
							v-html="itemUnicodeIcon(item) + '&#10240;'"
						></div>
						{{ itemText(item) }}
					</option>
				</select>
			</template>
			<template #validation>
				<slot name="validation"></slot>
			</template>
			<template
				#action
				v-if="util.hasKey($slots, 'action')"
			>
				<slot name="action"></slot>
			</template>
		</InputTextbox>
	</div>
</template>

<script>
	import InputTextbox from '@core/components/InputTextbox.vue';
	import util from '@core/services/util';
	import vstore from '@core/services/vstore';

	export default {
		name: 'InputDropdown',
		props: [
			'saturn',
			'cdk',
			'label',
			'unicodeIcon',
			'invalid',
			'disabled',
			'list',
			'text',
			'valueMap',
			'comparer',
			'copy',
			'cdkText',
			'nothingSelected',
			'itemDisabled',
			'infoIconObj',
			'cssClass',
			'clearable',
			'placeholder',
			'width',
			'height',
			'customOptionStyle',
		],
		data() {
			return {
				vm: {
					saturn: null,
					cdk: null,
					list: null,
					text: null,
					value: null,
					copy: null,
					disabled: null,
				},
				focused: false,
				errorHover: false,
				nullValue: null,
				blankValue: '',
				vstore: vstore.state,
			};
		},
		emits: ['update:saturn', 'change', 'blur', 'focus', 'cleared'],
		computed: {
			util() {
				return util;
			},
		},
		created() {
			this.init();
			// twoWayBind.listen(this, this.vm);
			this.$watch(
				() => this.$props,
				function (newValue) {
					this.init();
				},
				{ deep: true, immediate: true },
			);

			//@change="$emit('change')"
		},
		methods: {
			onChangeHandler(val) {
				// console.log("Dropdown change:", val)
				this.$emit('update:saturn', this.vm.saturn);
				this.$emit('change', this.vm.saturn);
			},
			onBlurHandler($e) {
				this.focused = false;
				this.$emit('blur', $e);
			},
			onFocusInput() {
				this.focused = true;
				this.$emit('focus');
			},
			handleClear() {
				this.$emit('cleared');
			},
			init() {
				this.vm.saturn = this.saturn;
				this.vm.cdk = this.cdk;
				this.vm.list = this.list;
				this.vm.unicodeIcon = this.unicodeIcon;
				this.vm.text = this.text;
				this.vm.value = this.valueMap;
				this.vm.cdkText = this.cdkText ? this.cdkText : this.cdk;
				this.vm.disabled = this.itemDisabled;
			},
			itemUnicodeIcon(item) {
				return this.isFunction(this.vm.unicodeIcon) ? this.vm.unicodeIcon(item) : this.isPrimitive(item) ? item : item[this.vm.unicodeIcon];
			},
			itemText(item) {
				if (this.isFunction(this.vm.text)) {
					return this.vm.text(item);
				} else if (this.isPrimitive(item)) {
					return item;
				} else {
					return item[this.vm.text];
				}
			},
			itemValue(item) {
				if (this.isFunction(this.vm.value)) {
					return this.vm.value(item);
				} else if (this.isPrimitive(item)) {
					return item;
				} else {
					return item[this.vm.value];
				}
			},

			/**
			 * @param {any} item
			 * if the value that is passed to the prop `itemDisabled` is a function, then use it (this.vm.disabled).
			 * else, return "disabled" in item (assuming its an object).
			 */
			itemIsDisabled(item) {
				return this.isFunction(this.vm.disabled) ? this.vm.disabled(item) : item.disabled;
			},
			isFunction(functionToCheck) {
				return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
			},
			isPrimitive(test) {
				return test !== Object(test);
			},
		},
		components: {
			InputTextbox,
		},
	};
</script>
